import { CohortState } from '../models/SubscriberCohortsModel';

// Same validated palette as the acquisition charts (constants/channelMix.ts
// in the acquisition module): categorical slots in fixed order, the blue ramp
// for magnitude and a neutral for "the rest".
export const ACCENT_COLOR = '#2a78d6';
export const HIGHLIGHT_COLOR = '#eb6834';
export const NEUTRAL_COLOR = '#c4c3bd';
export const SURFACE_COLOR = '#ffffff';
export const GRID_COLOR = '#ebedf3';
export const MUTED_TEXT_COLOR = '#898781';

// Current state of a cohort's plans. "Other" (payment failed, detained...)
// is the neutral remainder, not a fourth hue.
export const STATE_COLORS: Record<CohortState, string> = {
  active: '#2a78d6',
  paused: '#eb6834',
  cancelled: '#1baf7a',
  other: NEUTRAL_COLOR,
};

// Sequential blue ramp, light -> dark, one step per 10% of the value. Steps
// from WHITE_TEXT_FROM_STEP on are dark enough to need white text.
export const HEAT_STEPS = [
  '#cde2fb',
  '#b7d3f6',
  '#9ec5f4',
  '#86b6ef',
  '#6da7ec',
  '#3987e5',
  '#2a78d6',
  '#256abf',
  '#184f95',
  '#0d366b',
];
export const WHITE_TEXT_FROM_STEP = 6;

export function heatStep(intensity: number): number {
  return Math.min(
    Math.floor(intensity * HEAT_STEPS.length),
    HEAT_STEPS.length - 1
  );
}

// First month with paid orders on record: "whole history" starts here.
export const HISTORY_START_MONTH = '2021-09';
// Same cap as the backend serializer.
export const MAX_RANGE_MONTHS = 120;
export const DEFAULT_RANGE_MONTHS = 12;
export const QUICK_RANGES_MONTHS = [6, 12, 24];
